import { createSelector } from 'reselect';
import { authenticationSelector } from '../../authentication/ducks/selectors';
import { selectIsBettingServiceApiReady, selectIsSBApiReady } from './api/sportsbook-api-duck';
import { RootState } from '~/store/types';

/**
 * Check if user is authenticated, result is only true if the player is authenticated
 */
export const selectIsAuthenticated = createSelector(
	[authenticationSelector, selectIsBettingServiceApiReady],
	(isAuthenticatedInMV: boolean, isBettingServiceApiReady) => {
		return isAuthenticatedInMV && isBettingServiceApiReady;
	}
);

/**
 * Check if each api client is ready to be used. Consider both SB api, betting-service
 */
export const selectIsReadyForApiCalls = createSelector([selectIsSBApiReady], isSBApiReady => {
	return isSBApiReady;
});

export const selectIsSportsbookLobbyReady = (state: RootState) =>
	state !== null && state?.sportsbookLobby !== undefined;
